var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('object-fit-wrapper',{staticClass:"canvas-scrolly",attrs:{"aspectRatio":_vm.aspectRatio}},[[_c('canvas',{ref:"canvas"})]],2)}
var staticRenderFns = []

export { render, staticRenderFns }